import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CommonEditView from "../PortfolioEdit/components/CommonEditView/index";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import useAlert from "~/common/hooks/useAlert";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const PortfolioCreate = () => {
	const navigate = useNavigate();
	const [industryOptions, setIndustryOptions] = useState([]);
	const [showAddSuccessAlert, AddSuccessAlert] = useAlert();
	const industryRequest = useRequest("get", "vc/portfolio/industry");
	const portfolioAddRequest = useRequest("post", "vc/portfolio/add");

	const { t } = useTranslation();

	const handleSave = (formData) => {
		portfolioAddRequest.call(formData);
	};

	useEffect(() => {
		switch (portfolioAddRequest.state) {
			case API_STATE.done:
				showAddSuccessAlert().then(() => {
					navigate("/portfolio/list");
				});
				break;
			default:
				break;
		}
	}, [portfolioAddRequest.state, portfolioAddRequest.response]);

	useEffect(() => {
		industryRequest.asyncCall().then((res) => {
			const { data } = res;
			setIndustryOptions(data);
		});
	}, []);

	return (
		<>
			<Helmet>
				<title>{getTitle(t("pages.portfolio.PortfolioCreate.createPortfolio"))}</title>
			</Helmet>
			<CommonEditView industryOptions={industryOptions} onSave={handleSave} />
			<AddSuccessAlert
				type="success"
				message={t("pages.portfolio.PortfolioCreate.enrollSucessful")}
				confirm={t("pages.portfolio.PortfolioCreate.confirm")}
			/>
		</>
	);
};

export default PortfolioCreate;
